import type { CSSProperties } from 'react';

const CSS_GRADIENT_PATTERN =
  /^(?:linear|radial|conic|repeating-linear|repeating-radial|repeating-conic)-gradient\s*\(/i;

export const isCssGradient = (value: string): boolean => CSS_GRADIENT_PATTERN.test(value.trim());

export const getFacetColorSwatchClassName = (colorKey: string): string =>
  `bg-custom-${colorKey.toLowerCase()}`;

export interface ColorSwatchSurfaceProps {
  className: string;
  style?: CSSProperties;
}

const getInlineSwatchStyle = (customColor: string): CSSProperties =>
  isCssGradient(customColor) ? { backgroundImage: customColor } : { backgroundColor: customColor };

/** Same priority as product-card swatches: customColor first, then tailwind `custom-*` class. */
export const getColorSwatchSurfaceProps = (colorKey: string, hexColor?: string): ColorSwatchSurfaceProps => {
  const customColor = hexColor?.trim();

  if (!customColor) {
    return {
      className: getFacetColorSwatchClassName(colorKey),
      style: undefined,
    };
  }

  return {
    className: '',
    style: getInlineSwatchStyle(customColor),
  };
};
